var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _circle, _circle2, _circle3, _circle4, _line, _polygon, _rect50, _line2, _polygon2, _rect51, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _path, _circle29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndrawCalendarDutt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "3cd38589-f6b5-4ced-9f2c-9a4b79f01fae",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 835.61,
    height: 660.05,
    viewBox: "0 0 835.61 660.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "459c4fc8-d836-433f-a197-0a2a91cd58e2",
    x1: 435.61,
    y1: 529,
    x2: 435.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "342ea0e6-6062-49b7-bc20-c734cb7a73a4",
    x1: 435.61,
    y1: 488,
    x2: 435.61,
    y2: 95,
    xlinkHref: "#459c4fc8-d836-433f-a197-0a2a91cd58e2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "763d00b7-5a07-4818-8ebb-d18341e18e84",
    x1: 171.55,
    y1: 660.05,
    x2: 171.55,
    y2: 316.95,
    xlinkHref: "#459c4fc8-d836-433f-a197-0a2a91cd58e2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "92069d5c-e5f8-43fe-b38d-e54af900eab7",
    x1: 171.55,
    y1: 496.61,
    x2: 171.55,
    y2: 480.38,
    xlinkHref: "#459c4fc8-d836-433f-a197-0a2a91cd58e2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cc2cb1f8-9965-47fb-9589-218376181648",
    x1: 194.61,
    y1: 489.5,
    x2: 194.61,
    y2: 382.5,
    xlinkHref: "#459c4fc8-d836-433f-a197-0a2a91cd58e2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "21b9629b-50a9-4ebb-aca6-e4e0185f53fc",
    x1: 187.61,
    y1: 544.5,
    x2: 187.61,
    y2: 488.5,
    xlinkHref: "#459c4fc8-d836-433f-a197-0a2a91cd58e2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fcd1d80a-fd87-48d8-ac9f-c26a469979c7",
    x1: 509.54,
    y1: 778.88,
    x2: 509.54,
    y2: 769.85,
    gradientTransform: "translate(1170.3 491.9) rotate(120)",
    xlinkHref: "#459c4fc8-d836-433f-a197-0a2a91cd58e2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "103b5314-699c-4416-ba96-f0315aa2be6d",
    x1: 246.07,
    y1: 679.17,
    x2: 246.07,
    y2: 670.14,
    gradientTransform: "translate(370.3 -32.65) rotate(30)",
    xlinkHref: "#459c4fc8-d836-433f-a197-0a2a91cd58e2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f7eccc56-af47-4388-bae2-3610c4149eb5",
    x1: 364.44,
    y1: 766.03,
    x2: 364.44,
    y2: 756.99,
    gradientTransform: "translate(110.34 -349.73) rotate(30)",
    xlinkHref: "#459c4fc8-d836-433f-a197-0a2a91cd58e2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bcd8726a-d7c5-49b1-9a44-0b3978539435",
    x1: 643.63,
    y1: 719.48,
    x2: 643.63,
    y2: 710.44,
    gradientTransform: "translate(1232.03 299.71) rotate(120)",
    xlinkHref: "#459c4fc8-d836-433f-a197-0a2a91cd58e2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "391a46f9-b208-48d2-be26-d2096ab99e61",
    x1: 627.41,
    y1: 656.89,
    x2: 627.41,
    y2: 647.85,
    gradientTransform: "translate(1232.3 266.24) rotate(120)",
    xlinkHref: "#459c4fc8-d836-433f-a197-0a2a91cd58e2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "83f8f054-eb9c-442d-b51f-167d68b16295",
    x1: 643.63,
    y1: 594.29,
    x2: 643.63,
    y2: 585.26,
    gradientTransform: "translate(1248.8 237.12) rotate(120)",
    xlinkHref: "#459c4fc8-d836-433f-a197-0a2a91cd58e2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae1ae34d-eb1b-4711-a510-1c391231e596",
    x1: 690,
    y1: 547.93,
    x2: 690,
    y2: 538.89,
    gradientTransform: "translate(1278.2 220.15) rotate(120)",
    xlinkHref: "#459c4fc8-d836-433f-a197-0a2a91cd58e2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9891a10d-f6cd-4be8-8439-1a188b457eca",
    x1: 818.66,
    y1: 549.09,
    x2: 818.66,
    y2: 540.05,
    gradientTransform: "translate(1342.37 237.96) rotate(120)",
    xlinkHref: "#459c4fc8-d836-433f-a197-0a2a91cd58e2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fc0ab291-1c38-49b0-9137-a4534010b0cb",
    x1: 863.87,
    y1: 596.61,
    x2: 863.87,
    y2: 587.58,
    gradientTransform: "translate(1358.61 267.78) rotate(120)",
    xlinkHref: "#459c4fc8-d836-433f-a197-0a2a91cd58e2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "28dee737-f47b-4c6f-813e-2c0be0b581eb",
    x1: 877.78,
    y1: 656.89,
    x2: 877.78,
    y2: 647.85,
    gradientTransform: "translate(1357.49 299.78) rotate(120)",
    xlinkHref: "#459c4fc8-d836-433f-a197-0a2a91cd58e2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "228de15d-ea7a-43bb-9b48-ae33db5c4fe2",
    x1: 863.87,
    y1: 717.16,
    x2: 863.87,
    y2: 708.13,
    gradientTransform: "translate(1342.46 328.06) rotate(120)",
    xlinkHref: "#459c4fc8-d836-433f-a197-0a2a91cd58e2"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "calendar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35.61,
    width: 800,
    height: 529,
    fill: "url(#459c4fc8-d836-433f-a197-0a2a91cd58e2)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42.61,
    y: 62.5,
    width: 784,
    height: 450.5,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42.61,
    y: 11,
    width: 784,
    height: 51.5,
    fill: "#373737"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 53.61,
    y: 95,
    width: 764,
    height: 393,
    fill: "url(#342ea0e6-6062-49b7-bc20-c734cb7a73a4)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 63.11,
    y: 102,
    width: 92,
    height: 73.5,
    fill: "#373737",
    opacity: 0.5
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 156.11,
    y: 102,
    width: 92,
    height: 73.5,
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 249.11,
    y: 102,
    width: 92,
    height: 73.5,
    fill: "#373737",
    opacity: 0.2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 342.11,
    y: 102,
    width: 92,
    height: 73.5,
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 435.11,
    y: 102,
    width: 92,
    height: 73.5,
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 528.11,
    y: 102,
    width: 92,
    height: 73.5,
    fill: "#373737",
    opacity: 0.5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 621.11,
    y: 102,
    width: 92,
    height: 73.5,
    fill: "#fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 714.11,
    y: 102,
    width: 92,
    height: 73.5,
    fill: "#373737",
    opacity: 0.2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 63.11,
    y: 177,
    width: 92,
    height: 73.5,
    fill: "#373737",
    opacity: 0.2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 156.11,
    y: 177,
    width: 92,
    height: 73.5,
    fill: "#373737",
    opacity: 0.2
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 249.11,
    y: 177,
    width: 92,
    height: 73.5,
    fill: "#fff"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 342.11,
    y: 177,
    width: 92,
    height: 73.5,
    fill: "#373737",
    opacity: 0.5
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 435.11,
    y: 177,
    width: 92,
    height: 73.5,
    fill: "#fff"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 528.11,
    y: 177,
    width: 92,
    height: 73.5,
    fill: "#373737",
    opacity: 0.2
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 621.11,
    y: 177,
    width: 92,
    height: 73.5,
    fill: "#373737",
    opacity: 0.5
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 714.11,
    y: 177,
    width: 92,
    height: 73.5,
    fill: "#fff"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 63.11,
    y: 251,
    width: 92,
    height: 73.5,
    fill: "#fff"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 156.11,
    y: 251,
    width: 92,
    height: 73.5,
    fill: "#fff"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 249.11,
    y: 251,
    width: 92,
    height: 73.5,
    fill: "#373737",
    opacity: 0.2
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 342.11,
    y: 251,
    width: 92,
    height: 73.5,
    fill: "#fff"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 435.11,
    y: 251,
    width: 92,
    height: 73.5,
    fill: "#373737",
    opacity: 0.2
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 528.11,
    y: 251,
    width: 92,
    height: 73.5,
    fill: "#fff"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 621.11,
    y: 251,
    width: 92,
    height: 73.5,
    fill: "#fff"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 714.11,
    y: 251,
    width: 92,
    height: 73.5,
    fill: "#373737",
    opacity: 0.2
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 63.11,
    y: 325,
    width: 92,
    height: 73.5,
    fill: "#fff"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 156.11,
    y: 325,
    width: 92,
    height: 73.5,
    fill: "#373737",
    opacity: 0.5
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 249.11,
    y: 325,
    width: 92,
    height: 73.5,
    fill: "#373737",
    opacity: 0.5
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 342.11,
    y: 325,
    width: 92,
    height: 73.5,
    fill: "#fff"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 435.11,
    y: 325,
    width: 92,
    height: 73.5,
    fill: "#fff"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 528.11,
    y: 325,
    width: 92,
    height: 73.5,
    fill: "#373737",
    opacity: 0.5
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 621.11,
    y: 325,
    width: 92,
    height: 73.5,
    fill: "#fff"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 714.11,
    y: 325,
    width: 92,
    height: 73.5,
    fill: "#373737",
    opacity: 0.5
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 63.11,
    y: 400,
    width: 92,
    height: 73.5,
    fill: "#373737",
    opacity: 0.5
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 156.11,
    y: 400,
    width: 92,
    height: 73.5,
    fill: "#373737",
    opacity: 0.2
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 249.11,
    y: 400,
    width: 92,
    height: 73.5,
    fill: "#fff"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 342.11,
    y: 400,
    width: 92,
    height: 73.5,
    fill: "#373737",
    opacity: 0.5
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 435.11,
    y: 400,
    width: 92,
    height: 73.5,
    fill: "#373737",
    opacity: 0.2
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 528.11,
    y: 400,
    width: 92,
    height: 73.5,
    fill: "#fff"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 621.11,
    y: 400,
    width: 92,
    height: 73.5,
    fill: "#373737",
    opacity: 0.2
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 714.11,
    y: 400,
    width: 92,
    height: 73.5,
    fill: "#fff"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 70.61,
    y: 258,
    width: 28,
    height: 28,
    fill: "#69f0ae"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 348.61,
    y: 110,
    width: 28,
    height: 28,
    fill: "#69f0ae"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 345.61,
    y: 258,
    width: 28,
    height: 28,
    fill: "#69f0ae"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 440.61,
    y: 329,
    width: 28,
    height: 28,
    fill: "#69f0ae"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 625.61,
    y: 258,
    width: 28,
    height: 28,
    fill: "#69f0ae"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 171.55,
    cy: 488.5,
    r: 171.55,
    fill: "url(#763d00b7-5a07-4818-8ebb-d18341e18e84)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 171.55,
    cy: 488.5,
    r: 166.92,
    fill: "#373737"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 171.55,
    cy: 488.5,
    r: 135.62,
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 171.55,
    cy: 488.5,
    r: 8.11,
    fill: "url(#92069d5c-e5f8-43fe-b38d-e54af900eab7)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 216.76,
    y1: 384.18,
    x2: 172.71,
    y2: 488.5,
    fill: "#373737"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "174.61 489.5 169.61 487.82 214.61 382.5 219.61 384.85 174.61 489.5",
    fill: "url(#cc2cb1f8-9965-47fb-9589-218376181648)"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 320.31,
    y: 554.57,
    width: 113.24,
    height: 3.48,
    transform: "translate(-464.39 567.17) rotate(-67.11)",
    fill: "#2196f3"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 172.71,
    y1: 489.66,
    x2: 201.69,
    y2: 542.98,
    fill: "#373737"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "199.61 544.5 170.61 490.5 174.61 488.5 204.61 541.5 199.61 544.5",
    fill: "url(#21b9629b-50a9-4ebb-aca6-e4e0185f53fc)"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 367.66,
    y: 605.95,
    width: 3.48,
    height: 60.69,
    transform: "translate(-441.2 133.65) rotate(-28.52)",
    fill: "#2196f3"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 297.9,
    cy: 491.98,
    r: 3.48,
    fill: "#373737"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 244.91,
    cy: 545.99,
    r: 4.52,
    transform: "translate(-532.58 365.12) rotate(-60)",
    fill: "url(#fcd1d80a-fd87-48d8-ac9f-c26a469979c7)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.07,
    cy: 674.66,
    r: 4.52,
    transform: "translate(-486.56 93.44) rotate(-30)",
    fill: "url(#103b5314-699c-4416-ba96-f0315aa2be6d)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.21,
    cy: 491.98,
    r: 4.52,
    fill: "url(#f7eccc56-af47-4388-bae2-3610c4149eb5)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.04,
    cy: 499.63,
    r: 4.52,
    transform: "translate(-393.02 92.48) rotate(-30)",
    fill: "url(#bcd8726a-d7c5-49b1-9a44-0b3978539435)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 353.63,
    cy: 483.41,
    r: 4.52,
    transform: "translate(-376.52 121.6) rotate(-30)",
    fill: "url(#391a46f9-b208-48d2-be26-d2096ab99e61)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 416.23,
    cy: 499.63,
    r: 4.52,
    transform: "translate(-376.25 155.08) rotate(-30)",
    fill: "url(#83f8f054-eb9c-442d-b51f-167d68b16295)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 462.59,
    cy: 546,
    r: 4.52,
    transform: "translate(-393.22 184.47) rotate(-30)",
    fill: "url(#ae1ae34d-eb1b-4711-a510-1c391231e596)"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 461.43,
    cy: 674.66,
    r: 4.52,
    transform: "translate(-457.7 201.13) rotate(-30)",
    fill: "url(#9891a10d-f6cd-4be8-8439-1a188b457eca)"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.91,
    cy: 719.87,
    r: 4.52,
    transform: "translate(-486.68 183.42) rotate(-30)",
    fill: "url(#fc0ab291-1c38-49b0-9137-a4534010b0cb)"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 353.63,
    cy: 733.78,
    r: 4.52,
    transform: "translate(-501.71 155.15) rotate(-30)",
    fill: "url(#28dee737-f47b-4c6f-813e-2c0be0b581eb)"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 293.36,
    cy: 719.87,
    r: 4.52,
    transform: "translate(-502.83 123.15) rotate(-30)",
    fill: "url(#228de15d-ea7a-43bb-9b48-ae33db5c4fe2)"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 171.55,
    cy: 363.31,
    r: 3.48,
    fill: "#69f0ae"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 416.34,
    cy: 500.06,
    r: 3.48,
    transform: "translate(-407.09 490.61) rotate(-60)",
    fill: "#69f0ae"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 462.16,
    cy: 545.88,
    r: 3.48,
    transform: "translate(-393.22 184.24) rotate(-30)",
    fill: "#69f0ae"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 461.43,
    cy: 674.66,
    r: 3.48,
    transform: "translate(-535.75 616.96) rotate(-60)",
    fill: "#69f0ae"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 413.91,
    cy: 719.63,
    r: 3.48,
    transform: "translate(-486.56 183.39) rotate(-30)",
    fill: "#69f0ae"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 291.15,
    cy: 500.06,
    r: 3.48,
    transform: "translate(-393.22 92.6) rotate(-30)",
    fill: "#69f0ae"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.33,
    cy: 545.88,
    r: 3.48,
    transform: "translate(-532.27 365.43) rotate(-60)",
    fill: "#69f0ae"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 479.98,
    cy: 612.07,
    r: 4.52,
    transform: "translate(-423.92 202.02) rotate(-30)",
    fill: "#69f0ae"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.07,
    cy: 674.66,
    r: 3.48,
    transform: "translate(-486.56 93.44) rotate(-30)",
    fill: "#69f0ae"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 293.58,
    cy: 719.63,
    r: 3.48,
    transform: "translate(-658.62 494.09) rotate(-60)",
    fill: "#69f0ae"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.21,
    cy: 491.98,
    r: 3.48,
    fill: "#69f0ae"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 171.55,
    cy: 613.68,
    r: 3.48,
    fill: "#69f0ae"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M225.08,621.22a135.64,135.64,0,0,1,253.28-67.48A135.64,135.64,0,1,0,236.08,674.8,135.16,135.16,0,0,1,225.08,621.22Z",
    transform: "translate(-182.19 -119.97)",
    fill: "#373737",
    opacity: 0.2
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 171.55,
    cy: 488.5,
    r: 5.8,
    fill: "#69f0ae"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawCalendarDutt);
export default __webpack_public_path__ + "static/media/undraw_calendar_dutt.f394a6ba1847bc6a1b53fe9f73b9182d.svg";
export { ForwardRef as ReactComponent };